import { Loader2 } from 'lucide-react';

import type { BookingListItem, BookingSort, BookingSortDir } from '../../../api/bookingsList';
import { type WorkshopShell } from '../../dashboards/workshopDetailUrlFor';
import { BookingListCard } from '../BookingListCard';
import { BookingListTable } from '../BookingListTable';

interface BodyProps {
  loading: boolean;
  error: string | null;
  bookings: BookingListItem[];
  filtered: boolean;
  isDesktop: boolean;
  isTablet: boolean;
  sort: BookingSort;
  dir: BookingSortDir;
  onSort: (field: BookingSort) => void;
  shell: WorkshopShell;
}

export function BookingListBody({
  loading,
  error,
  bookings,
  filtered,
  isDesktop,
  isTablet,
  sort,
  dir,
  onSort,
  shell,
}: BodyProps) {
  if (error) {
    return (
      <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-600 dark:border-red-800 dark:bg-red-950/20 dark:text-red-400">
        {error}
      </div>
    );
  }
  if (loading) {
    return (
      <div className="flex items-center justify-center py-16">
        <Loader2 size={24} className="animate-spin text-stone-300" />
      </div>
    );
  }
  if (bookings.length === 0) {
    return (
      <div className="rounded-xl border border-stone-200 bg-white py-16 text-center text-sm text-stone-500 dark:border-stone-700 dark:bg-[#1a1f1c]">
        {filtered ? 'No bookings match your filters.' : 'No bookings yet.'}
      </div>
    );
  }
  if (isDesktop) {
    return (
      <BookingListTable bookings={bookings} sort={sort} dir={dir} onSort={onSort} shell={shell} />
    );
  }
  return (
    <div className={isTablet ? 'grid grid-cols-2 gap-4' : 'space-y-4'}>
      {bookings.map((b) => (
        <BookingListCard key={b.id} booking={b} shell={shell} />
      ))}
    </div>
  );
}
